__turbopack_context__.v({
  "actions": "infoWindow-module__zIV_Qa__actions",
  "btn": "infoWindow-module__zIV_Qa__btn",
  "btnCall": "infoWindow-module__zIV_Qa__btnCall" + " " + "infoWindow-module__zIV_Qa__btn",
  "btnMaps": "infoWindow-module__zIV_Qa__btnMaps" + " " + "infoWindow-module__zIV_Qa__btn",
  "content": "infoWindow-module__zIV_Qa__content",
  "detailItem": "infoWindow-module__zIV_Qa__detailItem",
  "details": "infoWindow-module__zIV_Qa__details",
  "header": "infoWindow-module__zIV_Qa__header",
  "locationNav": "infoWindow-module__zIV_Qa__locationNav",
  "locationNavText": "infoWindow-module__zIV_Qa__locationNavText",
  "name": "infoWindow-module__zIV_Qa__name",
  "navButton": "infoWindow-module__zIV_Qa__navButton",
  "pulse": "infoWindow-module__zIV_Qa__pulse",
  "selected": "infoWindow-module__zIV_Qa__selected",
});
